import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Modal, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import authSession from '@/utils/authSession';
import { getRequestErrorMessage } from '@/utils/requestError';
import './index.scss';

// 确认弹窗独立于下拉菜单，菜单关闭后仍保留确认、错误重试与提交锁。
const ActionMenu = ({ label, items, disabled = false, placement = 'bottomLeft', buttonProps = {} }) => {
  const [confirmation, setConfirmation] = useState(null);
  const [pending, setPending] = useState(false);
  const locked = useRef(false);
  const alive = useRef(false);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const availableItems = items.filter(Boolean);
  const selected = availableItems.find(item => item.key === confirmation);
  useEffect(() => { if (confirmation && !selected) setConfirmation(null); }, [confirmation, selected]);
  const busy = disabled || pending;
  const execute = async item => {
    if (busy || item.disabled || locked.current || !item.onClick) return;
    locked.current = true;
    setPending(true);
    const generation = authSession.getGeneration();
    const active = () => alive.current && generation === authSession.getGeneration();
    try {
      const result = await item.onClick();
      if (active() && result !== false) setConfirmation(null);
    } catch (error) {
      if (active()) message.error(getRequestErrorMessage(error, '操作失败，请重试'));
    } finally {
      locked.current = false;
      if (active()) setPending(false);
    }
  };
  if (!availableItems.length) return null;
  return <>
    <Dropdown trigger={['click']} placement={placement} disabled={busy} menu={{ items: availableItems.map(item => item.type ? item : {
      key: item.key, danger: item.danger, icon: item.icon, disabled: busy || item.disabled,
      label: <div className="actionMenu-item"><span>{item.label}</span>{item.disabled && item.disabledReason && <small>{item.disabledReason}</small>}</div>,
      onClick: () => {
        if (busy || item.disabled || locked.current) return;
        if (item.confirm) setConfirmation(item.key);
        else void execute(item);
      },
    }) }}>
      <Button {...buttonProps} disabled={busy || buttonProps.disabled}>{label}<DownOutlined aria-hidden="true" /></Button>
    </Dropdown>
    <Modal className="actionMenu-confirm" title={selected?.confirmTitle || '操作确认'} centered width={420} open={Boolean(selected?.confirm)} confirmLoading={pending}
      okText="确定" cancelText="取消" okButtonProps={{ danger: selected?.danger, disabled: busy || selected?.disabled }}
      cancelButtonProps={{ disabled: busy }} closable={!busy} keyboard={!busy} mask={{ closable: !busy }}
      onCancel={() => { if (!busy && !locked.current) setConfirmation(null); }}
      onOk={() => selected && execute(selected)}><p>{selected?.confirm}</p></Modal>
  </>;
};

export default ActionMenu;
